function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  d: "M5.656 8.682c0-.369.298-.667.666-.667.369 0 .667.298.667.667l.344 4.666c0 .368-.298.667-.666.667-.368 0-.667-.299-.667-.667l-.344-4.666zM9.68 8.015c-.369 0-.667.298-.667.667l-.35 4.666c0 .368.299.667.667.667.368 0 .667-.299.667-.667l.35-4.666c0-.369-.3-.667-.667-.667z"
});

var _ref3 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M10.667 3.348h2.01c1.098 0 1.99.896 1.99 2v.334c0 .716-.556 1.301-1.257 1.346-.024.003-.049.004-.074.004h-.019l-.004.003-.004.006v.002l-.668 7.639c0 1.104-.89 2-1.99 2H5.349c-1.1 0-1.99-.896-1.99-2l-.667-7.635-.001-.006c0-.002-.002-.004-.004-.006l-.005-.003-.006-.001c-.741 0-1.343-.604-1.343-1.35v-.333c0-1.104.891-2 1.99-2h2.01C5.333 1.876 6.527.682 8 .682c1.473 0 2.667 1.194 2.667 2.666zm-1.334 0c0-.736-.597-1.333-1.333-1.333s-1.333.597-1.333 1.333h2.666zm3.99 2.35h-1.988c-.368 0-.666.3-.666.667 0 .369.298.667.667.667h.645v.015l-.667 7.635c0 .368-.297.666-.663.666H5.349c-.366 0-.663-.298-.663-.666l-.667-7.635v-.015h3.314c.369 0 .667-.298.667-.667 0-.368-.298-.666-.667-.666H2.797l-.04.001c-.026-.002-.054-.002-.08-.002l-.007-.001-.005-.004-.004-.005v-.34c0-.368.296-.666.663-.666h9.352c.367 0 .664.298.664.666v.334l-.001.006-.004.005-.005.004h-.006z",
  clipRule: "evenodd"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.3815c5e4.svg";
export { ForwardRef as ReactComponent };